// Copyright (c) 2024 OPEN CASCADE SAS
//
// This file is part of commercial software by OPEN CASCADE SAS,
// furnished in accordance with the terms and conditions of the contract
// and with the inclusion of this copyright notice.
// This file or any part thereof may not be provided or otherwise
// made available to any third party.
//
// No ownership title to the software is transferred hereby.
//
// OPEN CASCADE SAS makes no representation or warranties with respect to the
// performance of this software, and specifically disclaims any responsibility
// for any damages, special or consequential, connected with its use.
import { OccViewer } from "../viewer/viewer.js";
/**
 * Auxiliary tool for operations between planes.
 */
export class PlaneTools {
    /** Return XY plane. */
    static xy() {
        return {
            location: { x: 0.0, y: 0.0, z: 0.0 },
            normal: { x: 0.0, y: 0.0, z: 1.0 },
        };
    }
    /** Return YZ plane. */
    static yz() {
        return {
            location: { x: 0.0, y: 0.0, z: 0.0 },
            normal: { x: 1.0, y: 0.0, z: 0.0 },
        };
    }
    /** Return ZX plane. */
    static zx() {
        return {
            location: { x: 0.0, y: 0.0, z: 0.0 },
            normal: { x: 0.0, y: 1.0, z: 0.0 },
        };
    }
    /** Return intersection line between planes. */
    static intersect(thePlane1, thePlane2) {
        return PlaneTools._myViewer.planeToolsIntersect(thePlane1, thePlane2);
    }
    /** set Viewer */
    static setViewer(theViewer) {
        PlaneTools._myViewer = theViewer;
    }
    /** Project point on plane */
    static project(thePoint, thePlane) {
        return PlaneTools._myViewer.planeToolsProject(thePoint, thePlane);
    }
}
/** Return _myViewer. */
PlaneTools._myViewer = null;
/**
 * Update [[ModelLoader]] in OccViewer.
 * @internal
 */
OccViewer.onInit((theModule) => {
    PlaneTools.setViewer(theModule);
});
